import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import header_img from '../assets/Image/DBC.jpg';
import axios from "../Component/axiosApis";
import i18n from '../Language/i18n';
import { Link } from "react-router-dom";
import Select from 'react-select';

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			head_status: this.props.data || "",
			languages: [
				{ "label": "English", "value": 'en' },
				{ "label": "Arabic", "value": 'ar' },
			],
			language: { "label": "English", "value": 'en' },
		}
	}

	componentDidMount() {
		var type = sessionStorage.getItem("language");
		if (type === "English") {
			this.setState({
				language: { "value": "en", "label": "English" }
			}, () => {
				i18n.changeLanguage("en");
			});
		} else if (type === "Arabic") {
			this.setState({
				language: { "label": "Arabic", "value": 'ar' }
			}, () => {
				i18n.changeLanguage("ar");
			});
		} else {
			i18n.changeLanguage("en");
		}
		axios
			.get("/conf/")
			.then(res => {
				var data = res && res.data && res.data.data || [];
				var img = data && data.logo ? `${data.logo}` : header_img;
				sessionStorage.setItem("ins_name", data && data.institution_name || "");
				this.setState({
					college_name: data && data.institution_name || "",
					college_address: data && data.address || "",
					college_img: img,
				})
			})
	}

	handleLang = (event) => {
		const { language } = this.state;
		var type = event.label;
		if (type !== language.label) {
			sessionStorage.setItem("language", type);
			window.location.reload()
		}
	}

	render() {
		const {
			college_name,
			college_address,
			college_img,
			head_status
		} = this.state;
		const { t } = this.props;
		return (
			<nav class="navbar navbar-expand-lg navbar-light bg-light header-fixed">
				<div className="col-md-12 row">
					<div className="col-md-8 col-sm-8">
						<div className="row">
							<div className="col-md-2 col-sm-2">
								<img
									alt=""
									src={college_img}
									style={{ width: '60px', height: '60px' }}
								/>
							</div>
							<div className="header_text">
								<h6>
									<b className="">{college_name}</b>
								</h6>
								<h6>
									{college_address}
								</h6>
							</div>
						</div>
					</div>
					{/*<div className="col-md-6 col-sm-7 text-center head-title">
				       		<h3 className="header_text">
	                           <b className="">{college_name}</b>
	                        </h3>
	                        <h5 className="" style={{ fontSize: '14px' }}>
	                           {college_address}
	                        </h5>
				       </div>*/}
					<div className="col-md-4 col-sm-4 head-lang">
						<div className="row">
							<div className="col-md-6 col-sm-6">
								<Select
									value={this.state.language}
									options={this.state.languages}
									onChange={this.handleLang.bind('this')}
									className="head-select"
								/>
							</div>
							<div className="col-md-6 col-sm-6">
								{
									head_status === "Home" ?
										<Link to="/">
											<button type="button"
												className="btn btn-sm mt-3 btn-primary"
												title={t("ver_app_lbl")}
											>
												{t("ver_app_btn")}
											</button>
										</Link>
										:
										<Link to="/status">
											<button type="button"
												className="btn btn-sm mt-3 btn-primary"
												title={t("ver_sta_lbl")}
											>
												{t("ver_sta_btn")}
											</button>
										</Link>
								}
							</div>
						</div>
					</div>
				</div>
			</nav>
		)
	}
}

export default withTranslation()(Header)